import Maps from './container'

export default Maps
